/* awtomic-theme-custom-ponzi.js — Ponzi Vineyards per-shop extensions.
 *
 * Loaded by snippets/awtomic-theme-custom.liquid ALONGSIDE the standard
 * Awtomic Build-a-Box kit (awtomic-theme-custom.js). This file carries the
 * shop-specific behaviors that predate the kit:
 *   - Full-page Build-a-Box (BaB) URL helper + The Scheme CTA wiring
 *     (sections/the-scheme-bab.liquid).
 *   - Body-class scoping so Customer Portal (CP) CSS only applies on Awtomic
 *     routes (/tools/bundle-subscriptions, /tools/recurring).
 *
 * DEFERRED: the cart ROLLUP behaviors (2-12 bottle min/max guard + group
 * remove that operate on .awt-bundle-line) are intentionally left out for now
 * and will be added later.
 *
 * Reversible + scoped: this file only adds behavior on Awtomic routes / for
 * elements it owns (data-awt-* hooks). It never mutates the theme's own
 * components, and it shares no globals with the kit file.
 */
(function () {
  'use strict';

  /* ---- 1. Full-page BaB URL helper -------------------------------------- */
  // Build the tools-route URL and navigate.
  function buildBabUrl(productId, handle, sellingPlan) {
    var url = '/tools/bundle-subscriptions/bundle/' + productId + '?product=' + encodeURIComponent(handle);
    if (sellingPlan) {
      url += '&selling_plan=' + encodeURIComponent(sellingPlan);
    }
    return url;
  }
  // Exposed for inline onclick parity, if a merchant wants to wire a
  // toggle/button manually.
  window.awtBuildBabUrl = buildBabUrl;

  // Progressive enhancement: any [data-awt-bab-link] already has a server-rendered
  // href; we only normalize it from the section's data-* attrs if present.
  function wireBabLinks() {
    var section = document.querySelector('.the-scheme-bab[data-bab-product-id]');
    if (!section) return;
    var pid = section.getAttribute('data-bab-product-id');
    var plan = section.getAttribute('data-bab-selling-plan');
    var handle = section.getAttribute('data-bab-handle');
    if (!pid || !handle) return;
    var href = buildBabUrl(pid, handle, plan);
    section.querySelectorAll('[data-awt-bab-link]').forEach(function (a) {
      // Only override if the server href is empty/relative-root (defensive).
      if (!a.getAttribute('href') || a.getAttribute('href') === '#') {
        a.setAttribute('href', href);
      }
    });
  }

  /* ---- 2. Customer Portal body-class scoping ---------------------------- */
  // Add a body class on Awtomic routes so awtomic-customer-portal.css applies
  // ONLY there (keeps the override scoped + reversible).
  function scopeCustomerPortal() {
    var p = window.location.pathname;
    if (p.indexOf('/tools/bundle-subscriptions') === 0 || p.indexOf('/tools/recurring') === 0) {
      document.body.classList.add('awt-customer-portal');
    }
    if (p.indexOf('/tools/bundle-subscriptions/bundle') === 0) {
      document.body.classList.add('awt-bab-open');
    }
  }

  /* ---- init ------------------------------------------------------------- */
  function init() {
    scopeCustomerPortal();
    wireBabLinks();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
